/**
 * Design tokens lifted from the prototype (ref/mockup/src/styles/tokens.ts) per
 * DEC-016/DEC-025. These are the single source of colour truth for the AntD
 * ConfigProvider theme (R-18.18: no hardcoded colours in components — components read
 * the theme, the theme reads these tokens). The sider stays dark in BOTH themes; only
 * header / content / body flip with the algorithm.
 *
 * The WCAG AA contrast audit from the mockup carries over: darkText on darkBody ≈
 * 17.9:1, lightText on lightBody ≈ 13.7:1, siderText on the #001529 sider ≈ 15.7:1 —
 * all AA-compliant (R-18.27). If you add a token, re-check contrast before merging.
 */

export const palette = {
  primary: '#1677FF',

  // Status / semantic (R-18.19): primary, success, warning, error, neutral.
  success: '#52C41A',
  warning: '#FAAD14',
  danger: '#FF4D4F',
  neutral: '#8C8C8C',

  // Region — dark theme.
  darkBody: '#000000',
  darkSider: '#001529',
  darkHeader: '#1F1F1F',
  darkContent: '#000000',
  darkTableHeader: '#1F1F1F',
  darkTableRowHover: '#141414',
  darkText: 'rgba(255, 255, 255, 0.85)',

  // Region — light theme (sider intentionally stays dark — DEC-025).
  lightBody: '#F5F5F5',
  lightSider: '#001529',
  lightHeader: '#FFFFFF',
  lightContent: '#FFFFFF',
  lightTableHeader: '#FAFAFA',
  lightText: 'rgba(0, 0, 0, 0.88)',
  lightSiderText: 'rgba(255, 255, 255, 0.85)',
} as const;

export const regions = {
  dark: {
    body: palette.darkBody,
    sider: palette.darkSider,
    header: palette.darkHeader,
    content: palette.darkContent,
    tableHeader: palette.darkTableHeader,
    tableRowHover: palette.darkTableRowHover,
    text: palette.darkText,
    siderText: palette.darkText,
  },
  light: {
    body: palette.lightBody,
    sider: palette.lightSider,
    header: palette.lightHeader,
    content: palette.lightContent,
    tableHeader: palette.lightTableHeader,
    text: palette.lightText,
    siderText: palette.lightSiderText,
  },
} as const;

export type ThemeMode = keyof typeof regions;
